// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__10jNf","row":"ProcedureTreatmentSummary_row__3Ze6Y"};